// Currencies offered in pickers. Any code with an ECB reference rate works
// server-side; these cover our markets.
export const CURRENCIES = ["NOK", "SEK", "DKK", "EUR", "ISK", "GBP", "USD", "CHF"];
